export function validateWhatsApp(phone: string): boolean {
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');

  // Must have exactly 11 digits (DDD + number) after removing any prefix
  if (digits.length !== 11) {
    return false;
  }
  return true;
}

export function formatWhatsApp(phone: string): string {
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');
  return digits;
}